"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

require("./card-list-item.scss");

var CardListItem = function CardListItem(_a) {
  var label = _a.label,
      value = _a.value,
      color = _a.color;
  return react_1["default"].createElement("div", {
    className: "card-list-item " + (color ? "color-" + color : "")
  }, label, react_1["default"].createElement("span", {
    className: "value"
  }, value));
};

exports.CardListItem = CardListItem;